// Thumbnail generator
const generateThumbnail = (id, spec, size, focus, series, decalID = null) => {
  let thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${spec}&type=prod&extra=(focus=${focus})&Size=${size}`;

  if (spec.indexOf('RGB') !== -1) {
    thumbnail = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(${spec})&type=prod&extra=(focus=${focus})&Size=${size}`;
  }

  if(series === "9700" && decalID){
    thumbnail = `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?specifier=!${decalID}&sel=-1&size=${size}&extra=(DESIGN=(MODEL=TILE),focus=(@size[x]/@res[x]/1in),size=(?,(@size[x]*@res[y]/@res[x])))`;
  }

  return thumbnail;
};

export { generateThumbnail };
